import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { Log } from "../models/Log";
import { SearchData } from "../models/SearchData";

const LogsInitialState: {
	logs: Log[];
	searchData: SearchData;
} = {
	logs: [],
	searchData: {
		Start: moment().add(-5, "days").hour(0).minute(0).second(0).toDate(),
		End: moment().hour(23).minute(59).second(59).toDate(),
		Search: "",
		LogTypeCode: "A",
	},
};

export const LogsReducer = createSlice({
	name: "__",
	initialState: LogsInitialState,
	reducers: {
		setLogs(state, { payload }) {
			state.logs = payload;
		},
		setSearchData(state, { payload }) {
			state.searchData = payload;
		},
		setStartFilter(state, { payload }) {
			state.searchData.Start = payload;
		},
		setEndFilter(state, { payload }) {
			state.searchData.End = payload;
		},
		setSearchFilter(state, { payload }) {
			state.searchData.Search = payload;
		},
		setLogTypeCodeFilter(state, { payload }) {
			state.searchData.LogTypeCode = payload;
		},
		resetFilters(state, { payload }) {
			state.searchData = {
				Start: moment().add(-5, "days").hour(0).minute(0).second(0).toDate(),
				End: moment().hour(23).minute(59).second(59).toDate(),
				Search: "",
				LogTypeCode: "A",
			};
		},
	},
});
